export default function useVariantsOption(variants) {
  return variants.reduce((prev, curr) => {
    return {
      ...prev,
      size_values: {
        ...(prev.size_values ?? {}),
        [curr.variant1_size]: [
          ...(prev.size_values?.[curr.variant1_size] ?? []),
          {
            ...curr,
            sku: curr.sku,
            color_values: curr.variant2_color,
            stock: curr.stock,
            variant_id: curr.variant_id,
            thumbnails: curr.thumbnails,
            harga: curr.price_tags,
            berat: curr.package_weight,
          },
        ],
      },
      color_values: {
        ...(prev.color_values ?? {}),
        [curr.variant2_color]: [
          ...(prev.color_values?.[curr.variant2_color] ?? []),
          {
            ...curr,
            sku: curr.sku,
            size_values: curr.variant1_size,
            stock: curr.stock,
            variant_id: curr.variant_id,
            thumbnails: curr.thumbnails,
            harga: curr.price_tags,
            berat: curr.package_weight,
          },
        ],
      },
    };
  }, {});
}
